export function lockScroll() {
  const y = window.scrollY || document.documentElement.scrollTop;
  document.documentElement.style.scrollBehavior = "auto"; // evita animaciones al restaurar
  document.body.style.position = "fixed";
  document.body.style.top = `-${y}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

// restablece scroll
export function unlockScroll() {
  const top = document.body.style.top;
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  const y = top ? -parseInt(top || "0", 10) : 0;
  window.scrollTo(0, y);
  document.documentElement.style.scrollBehavior = ""; // restaura
}